import React, { forwardRef } from 'react';
import { Form, Col } from 'react-bootstrap';
import classNames from 'classnames';

const InputText = forwardRef((props, ref) => {
    const {
        type,
        id,
        label = null,
        message = false,
        error = false,
        fullWidth = false,
        disabled = false,
        size = 'medium',
        mask = null,
        className,
        ...restProps
    } = props;

    const styles = {
        small: 'p-2 sm:text-xs',
        medium: 'p-2.5 text-sm',
        large: 'p-4 sm:text-md',
    };

    return (
        <>
            <Form.Group controlId={id} as={Col} className='mt-3'>
                {label != null && (
                    <Form.Label
                        className={''}>
                        {label}
                    </Form.Label>
                )}
                {type !== 'textarea' ?


                    <Form.Control
                        ref={ref}
                        type={type}
                        disabled={disabled}
                        className={classNames(
                            '',
                            { 'bg-gray-100': disabled },
                            styles[size],
                            className
                        )}
                        max={type === 'date' ? '9999-12-31' : null}
                        {...restProps}
                    />


                    :

                    <Form.Control
                        ref={ref}
                        as={type}
                        rows={3}
                        disabled={disabled}
                        className={classNames(
                            '',
                            { 'bg-gray-100': disabled },
                            styles[size],
                            className
                        )}
                        {...restProps}
                    />


                }
            </Form.Group>
            {Boolean(message) && (
                <span
                    className={classNames('mb-2 block text-sm font-medium', {
                        'text-red-700': error,
                    })}
                >
                    {message}
                </span>
            )}
        </>
    );
});

InputText.displayName = 'InputText';

export default InputText;
